import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { CourseTypeFormValues } from 'src/models/CourseType.model';
import CourseType from '../Layouts/CourseType';
import { useGetCourseTypeByIdQuery } from 'src/services/CourseTypeService';
import { useUpdateCourseTypeByIdMutation } from 'src/services/CourseTypeService';
import { showToast } from 'src/utils/showToaster';
import { CircularProgress } from '@mui/material';

type Props = {
  onClose: () => void;
  selectedCourseTypeId: string
};

const EditCourseTypeWrapper = ({ onClose, selectedCourseTypeId }: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } =
    useGetCourseTypeByIdQuery(selectedCourseTypeId);
  const [updateCourseTypeById] = useUpdateCourseTypeByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);


  const initialValues: CourseTypeFormValues = {
    courseType: items?.courseType || '',
  };

  // Validation Schema
  const validationSchema = object().shape({
    courseType: string().required('Please enter course type'),
  });

  // Handle Submit
  const handleSubmit = (
    values: CourseTypeFormValues,
    { setSubmitting, resetForm }: FormikHelpers<CourseTypeFormValues>
  ) => {
    updateCourseTypeById({ id: selectedCourseTypeId, body: values }).then(
      (res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      }
    );
  };

  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <CourseType formikProps={formikProps} onClose={onClose} formType='EDIT' />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditCourseTypeWrapper;